export const PRODUCTS = Object.freeze({
  NORAHUMAN: "norahuman",
  NOVATRA: "novatra",
});

export const PRODUCT_VALUES = Object.freeze(Object.values(PRODUCTS));

export const DEFAULT_PRODUCT_ACCESS = Object.freeze([PRODUCTS.NORAHUMAN]);

export const normalizeProductAccess = (productAccess) => {
  if (!Array.isArray(productAccess) || productAccess.length === 0) {
    return [...DEFAULT_PRODUCT_ACCESS];
  }

  const normalized = productAccess
    .map((product) =>
      typeof product === "string" ? product.trim().toLowerCase() : product,
    )
    .filter((product) => PRODUCT_VALUES.includes(product));

  return normalized.length ? Array.from(new Set(normalized)) : [...DEFAULT_PRODUCT_ACCESS];
};
